import React from "react";
import styles from "./hero.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faArrowRight, faCheck, faCode, faLaptop} from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";

const Hero: React.FC = () => {
    const { t } = useTranslation();

    return (
        <section className={styles.sectionWrapper}>

            {/* YOUR GRID — UNTOUCHED */}
            <div className={styles.gridContainer}>
                <div className={styles.leftContainer}>
                    <h1 className={styles.headline}>
                        Custom Web Applications Engineered for Business Operations
                    </h1>
                    <div className={styles.sub_headLine}>
                        <p>
                            Custom systems built to scale, automate workflows, and support real-world usage from day one.
                        </p>
                    </div>
                    <a href="/contact" className={styles.btnPrimary}>
                        Get a Free Quote
                    </a>
                </div>
                {/* WHAT YOU GET*/}
                <div className={styles.card}>
                    <div className={styles.card_title}>
                        WHAT YOU GET
                    </div>
                    <div className={styles.content}>
                        <div className={styles.listItem}>
                            <div className={styles.icon_container}>
                                <FontAwesomeIcon icon={faCheck} style={{color:"darkturquoise"}}/>
                            </div>
                            <p className={styles.listItemText}>Scalable Application Architecture</p>
                        </div>
                        <div className={styles.listItem}>
                            <div className={styles.icon_container}>
                                <FontAwesomeIcon icon={faCheck} style={{color:"darkturquoise"}}/>
                            </div>
                            <p className={styles.listItemText}>Secure & Reliable Systems</p>
                        </div>
                        <div className={styles.listItem}>
                            <div className={styles.icon_container}>
                                <FontAwesomeIcon icon={faCheck} style={{color:"darkturquoise"}}/>
                            </div>
                            <p className={styles.listItemText}>High-Performance Applications</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Hero;
